import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-95" data-mp="x5mrs7mfwbkj">
      <div className="max-w-3xl mx-auto" data-id="element-96" data-mp="123oc0vvlqgxl">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta text-center leading-tight" data-id="element-97" data-mp="124g9kc8reoqi">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-98" data-mp="1uq92lu496p03">
          {FAQS.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.pregunta} className="rounded-2xl bg-white border border-black/5 shadow-sm overflow-hidden" data-id="element-99" data-mp="1g0bj3rh9qnh8" data-mpi={i}>
                <h3 data-id="element-100" data-mp="28qa5tg7zq8iq">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-5 font-semibold text-violeta" data-id="element-101" data-mp="28oz0hbywcspi">
                    <span className="text-base sm:text-lg" data-id="element-102" data-mp="2yg1v8zwdxk4c">{faq.pregunta}</span>
                    <motion.span animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.25,
                  ease: 'easeOut'
                }} className="shrink-0 text-coral" data-id="element-103" data-mp="2yi4rw2s1mbi1">
                      <ChevronDownIcon className="w-5 h-5" aria-hidden="true" data-id="element-104" data-mp="32iezfjvhh9z0" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-105" data-mp="3hcjvk5pausc7">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} data-id="element-106" data-mp="3cgky7slztzzn">
                      <p className="px-5 sm:px-6 pb-5 text-tinta/80 leading-relaxed" data-id="element-107" data-mp="2br9dld8t051l">
                        {faq.respuesta}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}